import { Link } from "react-router";
import { Alerta, Button, Combobox, CopyField, Row, Stack, type OpcionCombobox } from "@/components";
import type { TemporalGenerada } from "@/lib/usuarios";

/** La contraseña temporal recién generada: se ve una sola vez (en la base queda sólo el hash). La usan Usuarios y Fiduciantes. */
export function PasswordTemporalParaCompartir({ datos }: { datos: TemporalGenerada }) {
  return (
    <Stack espacio={3}>
      <p>Dictásela o mandásela a {datos.nombre}. Al entrar elige la suya.</p>
      <CopyField etiqueta="Contraseña temporal" valor={datos.password} />
      <p className="text-chico text-texto-suave">Vence el {datos.vence}. Se muestra una sola vez: si se pierde o vence, generá otra desde Usuarios.</p>
    </Stack>
  );
}

export interface ElegirFichaProps {
  opciones: OpcionCombobox[];
  /** Nombre de la ficha elegida, o null para buscarla. */
  elegida: string | null;
  onElegir: (valor: string) => void;
  onSoltar: () => void;
  sinFichasLibres: boolean;
  error: string | null;
}

/** Elegir la ficha de fiduciante (sin usuario) que se vincula al usuario. */
export function ElegirFicha({ opciones, elegida, onElegir, onSoltar, sinFichasLibres, error }: ElegirFichaProps) {
  if (error) return <Alerta texto={`No se pudieron cargar las fichas de fiduciantes: ${error}`} />;
  if (elegida !== null) {
    return (
      <Stack espacio={1}>
        <span className="text-chico font-medium">Ficha del fiduciante</span>
        <Row espacio={2} envolver>
          <span className="font-medium">{elegida}</span>
          <Button variante="fantasma" tamanio="sm" aria-label="Elegir otra ficha" onClick={onSoltar}>
            Cambiar
          </Button>
        </Row>
      </Stack>
    );
  }
  if (sinFichasLibres) {
    return (
      <Alerta
        tono="alerta"
        texto="Todas las fichas de fiduciantes ya tienen usuario."
        accion={<Link to="/fiduciantes" className="font-medium underline underline-offset-2">Cargalo primero en Fiduciantes</Link>}
      />
    );
  }
  return <Combobox etiqueta="Ficha del fiduciante" opciones={opciones} onElegir={onElegir} placeholder="Escribí para buscar" />;
}
